interface SheetConfig {
  defaultSheetUrl: string;
  defaultRange: string;
}

const defaultSheets: Record<string, SheetConfig> = {
  BuyerByProduct: {
    defaultSheetUrl: 'https://docs.google.com/spreadsheets/d/1S58DKSllhK2n--HOEdCMSLQg-mPpYxcOsXRmBQiOoYA/edit?gid=1383959819#gid=1383959819',
    defaultRange: 'A:E'
  },
  BuyerVendor: {
    defaultSheetUrl: 'https://docs.google.com/spreadsheets/d/1KakAQDGlPwqPYrzK6weXGKFFju8gfMkUX2tpVLjL17U/edit?gid=0#gid=0',
    defaultRange: 'A:D'
  },
  CustomerGroup: {
    defaultSheetUrl: 'https://docs.google.com/spreadsheets/d/1a-NyspA7zwlQdJUQaO0RgTQpMc8xlJFB4jkA_wyNXI0/edit?gid=0#gid=0',
    defaultRange: 'A:C'
  },
  CreditReport: {
    defaultSheetUrl: 'https://docs.google.com/spreadsheets/d/1F5TPzDPhZAa_dPtSYYZXRuY0neKGcWrkvstun2FVTRE/edit?gid=0#gid=0',
    defaultRange: 'A:N'
  },
  DateMapping: {
    defaultSheetUrl: 'https://docs.google.com/spreadsheets/d/1RUFEcfBt-ZXodJfRqqnocTsp3lmwCIluN8kJVufmp_g/edit?gid=0#gid=0',
    defaultRange: 'A:F'
  },
  ProductGroup: {
    defaultSheetUrl: 'https://docs.google.com/spreadsheets/d/1t6_R6hqVLvOlgljGPEfOgtUQmImJEGlpX6mZpZAdMeQ/edit?gid=0#gid=0',
    defaultRange: 'A:C'
  },
  SalesRepDepartment: {
    defaultSheetUrl: 'https://docs.google.com/spreadsheets/d/17-BfWYZ0EBdHiUDoXm-kHm6cxqrQN1nlz6ePiCQ59j8/edit?gid=0#gid=0',
    defaultRange: 'A:B'
  },
  Salesmen: {
    defaultSheetUrl: 'https://docs.google.com/spreadsheets/d/1cpU_yQgA8HUAJVXa9FcUitcPulX-hicwK6J_iu2MrO0/edit?gid=0#gid=0',
    defaultRange: 'A:D'
  }
};

export default defaultSheets;
